export default class CustomerData {

	constructor(customerAccount) {
		customerAccount = customerAccount || {};
		const {name = {}} = customerAccount;
		const {address = {}} = customerAccount;
		const {contactInformation = {}} = customerAccount;
		const {billingAccount = {}} = customerAccount;
		const {bankCoordinates = {}} = billingAccount;
			this.userName = customerAccount.customer;
			this.code = customerAccount.code;
			this.password = "";
			this.password_confirmation = "";

			const {title = ""} = name;
			this.title = title;
			const {firstName = ""} = name;
			this.firstName = firstName;
			const {lastName = ""} = name;
			this.lastName = lastName;

			const {email = ""} = contactInformation;
			this.email = email;
			const {mobile = ""} = contactInformation;
			this.mobile = mobile || "";

			const {address1 = ""} = address;
			this.address1 = address1 || "";
			const {address2 = ""} = address;
			this.address2 = address2 || "";
			const {address3 = ""} = address;
			this.address3 = address3 || "";
			const {zipCode = ""} = address;
			this.zipCode = zipCode;
			const {country = ""} = address;
			this.country = country;
			const {city = ""} = address;
			this.city = city || "";

			const {paymentMethod = ""} = customerAccount;
			this.paymentMethod = paymentMethod || "";
			const {electronicBilling = false} = billingAccount;
			this.electronicBilling = electronicBilling;
			const {billingCycle = ""}  = billingAccount;
			this.billingCycle = billingCycle;
			this.billingEmail = billingAccount.email || "";

	}
}



// WEBPACK FOOTER //
// ./src/opencell/model/account/CustomerData.js